import { SortOrder } from 'antd/lib/table/interface';
import { Order } from 'gql/types';
import { ISortOption } from 'modules/common/interfaces';

export const createSortOrderFactory = <T>(
  sortOption: ISortOption<T> | undefined
) => {
  return (fieldName: T): SortOrder | undefined => {
    if (sortOption?.fieldName === fieldName) {
      return sortOption.order === Order.Asc ? 'ascend' : 'descend';
    }
    return undefined;
  };
};
